<template>
	<div class="agreement-container">
		<div class="agreement-main">
			<div class="agreement-content">
				<div class="term-content">
					<h3 class="agreement-title">楚建通用户注册协议</h3>
					<div class="term-box">
						<div class="term-text">
							<p class="intro">
								本协议是您与楚建通（简称"本站"，网址：chujt.com）所有者武汉佳软信息技术有限公司（以下简称为"佳软"）之间就楚建通服务等相关事宜所订立的契约，请您仔细阅读本注册协议，您点击"同意并继续"按钮后，本协议即构成对双方有约束力的法律文件。
							</p>

							<div class="term-item">
								<div class="term-number">1</div>
								<div class="term-desc">
									<b>本站服务条款的确认和接纳</b>
									<p>
										1.1、本站的各项电子服务的所有权和运作权归佳软所有。用户同意所有注册协议条款并完成注册程序，才能成为本站的正式用户。用户确认：本协议条款是处理双方权利义务的契约，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定。
									</p>
									<p>
										1.2、用户点击同意本协议的，即视为用户确认自己具有享受本站服务、下单购物等相应的权利能力和行为能力，能够独立承担法律责任。
									</p>
									<p>1.3、如果您在18周岁以下，您只能在父母或监护人的监护参与下才能使用本站。</p>
									<p>
										1.4、佳软保留在中华人民共和国大陆地区法施行之法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容或取消订单的权利。
									</p>
								</div>
							</div>

							<div class="term-item">
								<div class="term-number">2</div>
								<div class="term-desc">
									<b>本站服务</b>
									<p>
										2.1、佳软通过互联网依法为用户提供互联网信息等服务，用户在完全同意本协议及本站规定的情况下，方有权使用本站的相关服务。
									</p>
									<p>
										2.2、用户必须自行准备如下设备和承担如下开支：（1）上网设备，包括并不限于电脑或者其他上网终端、调制解调器及其他必备的上网装置；（2）上网开支，包括并不限于网络接入费、上网设备租用费、手机流量费等。
									</p>
								</div>
							</div>

							<div class="term-item">
								<div class="term-number">3</div>
								<div class="term-desc">
									<b>用户信息</b>
									<p>
										3.1、用户应自行诚信向本站提供注册资料，用户同意其提供的注册资料真实、准确、完整、合法有效，用户注册资料如有变动的，应及时更新其注册资料。如果用户提供的注册资料不合法、不真实、不准确、不详尽的，用户需承担因此引起的相应责任及后果，并且楚建通保留终止用户使用佳软各项服务的权利。
									</p>
									<p>
										3.2、用户在本站进行浏览、下单购物等活动时，涉及用户真实姓名/名称、通信地址、联系电话、电子邮箱等隐私信息的，本站将予以严格保密，除非得到用户的授权或法律另有规定，本站不会向外界披露用户隐私信息。
									</p>
									<p>
										3.3、用户注册成功后，将产生用户名和密码等账户信息，您可以根据本站规定改变您的密码。用户应谨慎合理的保存、使用其用户名和密码。用户若发现任何非法使用用户账号或存在安全漏洞的情况，请立即通知本站并向公安机关报案。
									</p>
									<p>
										3.4、用户在本站注册的账户，只允许用户本人使用，未经楚建通同意，不得直接或间接授权他人使用，否则承担由此产生的全部责任，并与实际使用人承担连带责任。
									</p>
									<p>
										3.5、用户注册完成后，楚建通提供账号注销服务，您可以联系客服申请注销您的账号，客服会在10个工作日内完成注销事项。注销账号之后，我们将停止为您提供产品或服务，同步删除包括但不限于您账号下绑定的个人信息、会员信息、会员权益、认证信息、收藏信息、订单信息等且无法恢复。
									</p>
								</div>
							</div>

							<div class="term-item">
								<div class="term-number">4</div>
								<div class="term-desc">
									<b>用户依法言行义</b>
									<p>
										本协议依据国家相关法律法规规章制定，用户同意严格遵守以下义务：
									</p>
									<p>
										（1）不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；
									</p>
									<p>
										（2）从中国大陆向境外传输资料信息时必须符合中国有关法规；
									</p>
									<p>
										（3）不得利用本站从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；
									</p>
									<p>
										（4）不得干扰本站的正常运转，不得侵入本站及国家计算机信息系统；
									</p>
									<p>
										（5）不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽的、不文明的等信息资料；
									</p>
									<p>
										（6）不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；
									</p>
									<p>（7）不得教唆他人从事本条所禁止的行为；</p>
									<p>（8）不得利用在本站注册的账户进行牟利性经营活动；</p>
									<p>（9）不得发布任何侵犯他人著作权、商标权等知识产权或合法权利的内容；</p>
									<p>用户应不时关注并遵守本站不时公布或修改的各类合法规则规定。</p>
									<p>本站保有删除站内各类不符合法律政策或不真实的信息内容而无须通知用户的权利。</p>
									<p>
										若用户未遵守以上规定的，本站有权作出独立判断并采取暂停或关闭用户账号等措施。用户须对自己在网上的言论和行为承担法律责任。
									</p>
								</div>
							</div>

							<div class="term-item">
								<div class="term-number">5</div>
								<div class="term-desc">
									<b>套餐信息</b>
									<p>
										本站上的套餐价格等商品信息随时都有可能发生变动，本站不作特别通知。
									</p>
								</div>
							</div>

							<div class="term-item">
								<div class="term-number">6</div>
								<div class="term-desc">
									<b>升级VIP</b>
									<p>
										在您升级VIP用户时，请您仔细确认所选套餐的名称、价格等信息。
									</p>
								</div>
							</div>

							<div class="term-item">
								<div class="term-number">7</div>
								<div class="term-desc">
									<b>所有权及知识产权条款</b>
									<p>
										7.1、用户一旦接受本协议，即表明该用户主动将其在任何时间段在本站发表的任何形式的信息内容（包括但不限于评价等信息内容）的财产性权利等任何可转让的权利，如著作权财产权（包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利），全部独家且不可撤销地转让给佳软所有，用户同意楚建通有权就任何主体侵权而单独提起诉讼。
									</p>
									<p>
										7.2、本协议已经构成《中华人民共和国著作权法》第二十五条（条文序号依照2011年版著作权法确定）及相关法律规定的著作财产权等权利转让书面协议，其效力及于用户在本站上发布的任何受著作权法保护的作品内容，无论该等内容形成于本协议订立前还是本协议订立后。
									</p>
									<p>
										7.3、用户同意并已充分了解本协议的条款，承诺不将已发表于本站的信息，以任何形式发布或授权其它主体以任何方式使用（包括但不限于在各类网站、媒体上使用）。
									</p>
									<p>
										7.4、佳软是本站的制作者,拥有此网站内容及资源的著作权等合法权利,受国家法律保护,有权不时地对本协议及本站的内容进行修改，并在本站张贴，无须另行通知用户。在法律允许的最大限度范围内，佳软对本协议及本站内容拥有解释权。
									</p>
									<p>
										7.5、除法律另有强制性规定外，未经佳软明确的特别书面许可,
										用户不得修改、改编、翻译本站上的系列产品和服务，或创作我们产品和服务的派生作品，或通过爬取、反编译、反向工程、反汇编或其它方式从我们产品和服务中得到源代码或数据。用户使用账号时，不得存在连续、频繁的查询操作行为，否则我们的后台将自动对您的账号封号且无需向您承担任何责任。用户每次使用完毕，请安全退出账号。若您存在上述情形，则我们有权终止提供服务并保留向您主张损失的权利。用户行为若涉嫌犯罪，将交由司法机关处理。
									</p>
									<p>
										7.6、本站所刊登的资料信息（诸如文字、图表、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件），均是佳软或其内容提供者的财产，受中国和国际版权法的保护。本站上所有内容的汇编是佳软的排他财产，受中国和国际版权法的保护。本站上所有软件都是佳软或其关联公司或其软件供应商的财产，受中国和国际版权法的保护。
									</p>
								</div>
							</div>

							<div class="term-item">
								<div class="term-number">8</div>
								<div class="term-desc">
									<b>责任限制及不承诺担保</b>
									<p>
										8.1、除非另有明确的书面说明,本站及其所包含的或以其它方式通过本站提供给您的全部信息、内容、材料、产品（包括软件）和服务，均是在"按现状"和"按现有"的基础上提供的。
									</p>
									<p>
										8.2、除非另有明确的书面说明,佳软不对本站的运营及其包含在本网站上的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。
									</p>
									<p>
										8.3、佳软不担保本站所包含的或以其它方式通过本站提供给您的全部信息、内容、材料、产品（包括软件）和服务、其服务器或从本站发出的电子信件、信息没有病毒或其他有害成分。
									</p>
									<p>
										8.4、如因不可抗力或其它本站无法控制的原因使本站销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，佳软会合理地尽力协助处理善后事宜。
									</p>
								</div>
							</div>

							<div class="term-item">
								<div class="term-number">9</div>
								<div class="term-desc">
									<b>协议更新及用户关注义务</b>
									<p>
										根据国家法律法规变化及网站运营需要，佳软有权对本协议条款不时地进行修改，修改后的协议一旦被张贴在本站上即生效，并代替原来的协议。用户可随时登录查阅最新协议；用户有义务不时关注并阅读最新版的协议及网站公告。如用户不同意更新后的协议，可以且应立即停止接受网站依据本协议提供的服务；如用户继续使用本网站提供的服务的，即视为同意更新后的协议。佳软建议您在使用本站之前阅读本协议及本站的公告。如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。
									</p>
								</div>
							</div>

							<div class="term-item">
								<div class="term-number">10</div>
								<div class="term-desc">
									<b>法律管辖和适用</b>
									<p>
										本协议的订立、执行和解释及争议的解决均应适用在中华人民共和国大陆地区适用之有效法律（但不包括其冲突法规则）。如发生本协议与适用之法律相抵触时，则这些条款将完全按法律规定重新解释，而其它有效条款继续有效。如缔约方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向有管辖权的中华人民共和国大陆地区法院提起诉讼。
									</p>
								</div>
							</div>

							<div class="term-item">
								<div class="term-number">11</div>
								<div class="term-desc">
									<b>其他</b>
									<p>
										11.1、网站所有者是指在政府部门依法许可或备案的网站经营主体。
									</p>
									<p>
										11.2、佳软尊重用户和消费者的合法权利，本协议及本网站上发布的各类规则、声明等其他内容，均是为了更好的、更加便利的为用户和消费者提供服务。本站欢迎用户和社会各界提出意见和建议，佳软将虚心接受并适时修改本协议及本站上的各类规则。
									</p>
									<p>
										11.3、您点击本协议下方的"同意并继续"按钮即视为您完全接受本协议，在点击之前请您再次确认已知悉并完全理解本协议的全部内容。
									</p>
								</div>
							</div>

							<div class="term-footer">
								<div class="platform-name">楚建通</div>
								<div class="publish-date">更新日期：2025年06月03日</div>
								<div class="publish-date">生效日期：2025年06月03日</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// 用户注册协议
	export default {
		name: 'RegAgreement',
		components: {},
		props: {},
		data() {
			return {}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped>
	.agreement-container {
		height: 70vh;
		overflow-y: scroll;
		background-color: #f7f7f7;

		.agreement-content {
			.term-content {
				width: $main-page-width;
				margin: 0 auto;
				padding: 50px 0;

				.term-box {
					background-color: #fff;
					border-radius: 10px;
					box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
					padding: 40px 60px;

					.term-text {
						font-size: 16px;
						color: #333;
						line-height: 1.8;

						.greeting {
							font-size: 18px;
							margin-bottom: 20px;
						}

						.intro,
						.conclusion {
							margin-bottom: 10px;
						}

						.term-item {
							display: flex;
							margin-bottom: 10px;

							.term-number {
								width: 30px;
								height: 30px;
								// background: linear-gradient(90deg, #ffc664 0%, #ff9538 100%);
								background: #2671cb;
								border-radius: 50%;
								color: #fff;
								font-weight: bold;
								display: flex;
								align-items: center;
								justify-content: center;
								margin-right: 15px;
								flex-shrink: 0;
								margin-top: 3px;
							}

							.term-desc {
								flex: 1;

								b {
									color: #236fca;
									font-size: 17px;
								}

								p {
									margin: 8px 0;
								}
							}
						}
					}
				}
			}
		}

		.agreement-title {
			font-size: 26px;
			color: #333;
			text-align: center;
			margin-bottom: 40px;
			position: relative;

			&::after {
				content: '';
				display: block;
				width: 60px;
				height: 3px;
				background: #236fca;
				margin: 15px auto 0;
			}
		}

		.term-footer {
			margin-top: 40px;
			text-align: right;
			font-size: 16px;
			color: #666;
			border-top: 1px solid #eee;
			padding-top: 20px;

			.platform-name {
				font-weight: bold;
				margin-bottom: 5px;
			}

			.publish-date {
				font-style: italic;
			}
		}
	}
</style>
